<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 md12>
        <v-text-field
          class="purple-input"
          label="Nome"
          messages="Nome profissional/pseudônimo. Será utilizado na distribução de conteúdos em todas as plataformas digitais."
          v-model="compositor.name"
        />
      </v-flex>

      <v-flex xs12 md6>
        <v-select
          v-model="compositor.society"
          :items="sociedades"
          item-text="name"
          item-value="value"
          label="Sociedade"
          messages="Digite a sociedade a qual esse compositor está associado."
          return-object
          single-line
        ></v-select>
      </v-flex>

      <v-flex xs12 md6>
        <v-text-field
          class="purple-input"
          label="Código CAE/IPI"
          messages="Código CAE/IPI geralmente 9 digitos podendo começar com 'I'. <br><br>Exemplo: XXX.XX.XX.XX"
          v-model="compositor.cae_ipi"
        />
      </v-flex>

      <v-flex xs12 md12 v-if="compositor.custom_name">
        <v-text-field
          class="purple-input"
          label="Nome"
          messages="Nome customizado. Enviado através da API."
          v-model="compositor.custom_name"
          disabled
        />
      </v-flex>

      <v-flex xs6 md6 py-4>
        <v-switch
          v-model="compositor.is_company"
          :label="`Este compositor é representado por uma empresa?`"
          messages="Caso o compositor tenha empresa é necessário marcar essa opção."
        ></v-switch>
      </v-flex>

      <v-flex xs12 md12 v-if="compositor.is_company">
        <v-text-field
          class="purple-input"
          label="Razão Social"
          messages="Digite a Razão Social da Empresa"
          v-model="compositor.br_razao_social"
        />
      </v-flex>

      <v-flex xs12 md12 v-if="compositor.is_company">
        <v-text-field
          class="purple-input"
          label="Nome Fantasia"
          messages="Digite o nome fantasia da empresa"
          v-model="compositor.br_nome_fantasia"
        />
      </v-flex>

      <v-flex xs12 md12 v-if="compositor.is_company">
        <v-text-field
          class="purple-input"
          label="CNPJ"
          messages="Digite o CNPJ da Empresa"
          v-model="compositor.br_cnpj"
        />
      </v-flex>

      <v-flex xs12 md6 v-if="compositor.is_company">
        <v-text-field
          class="purple-input"
          label="Banco"
          messages="Digite o nome do Banco"
          v-model="compositor.bank"
        />
      </v-flex>

      <v-flex xs12 md3 v-if="compositor.is_company">
        <v-text-field
          class="purple-input"
          label="Agência"
          messages="Digite a agência sem digito verificador"
          v-model="compositor.bank_agency"
        />
      </v-flex>
      <v-flex xs12 md3 v-if="compositor.is_company">
        <v-text-field
          class="purple-input"
          label="Conta"
          messages="Digite a conta do seu banco com o digito verificador"
          v-model="compositor.bank_account"
        />
      </v-flex>

      <!--v-flex xs12 md12 pt-5>
        <v-btn color="primary" @click="salvar()">Salvar</v-btn>
      </v-flex-->
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    compositor: {},
    sociedades: [
      { name: "Nenhuma", value: "" },
      { name: "Abramus", value: "abramus" },
      { name: "Amar", value: "amar" },
      { name: "Assim", value: "assim" },
      { name: "Sbacem", value: "sbacem" },
      { name: "Sicam", value: "sicam" },
      { name: "Socinpro", value: "socinpro" },
      { name: "UBC", value: "ubc" }
    ]
  }),
  props:{
    composer_data: Object
  },
  methods: {},
  watch: {
    compositor:{
      handler: function() {        
        this.$emit("compositor_data", this.compositor);
      },
      deep:true
    },
    composer_data: function(){
      this.compositor = this.composer_data;
    }
  }
};
</script>


